export default __webpack_public_path__ + "static/media/coronavirus.4e06cbbe.jpg";